/*
 *  Komponentenweite Textkonstanten.
 */
export const Messages = Object.freeze({
  WEITERBILDUNG_EINGABEFELD_LABEL: 'Sucheingabe Weiterbildungsangebote',
  WEITERBILDUNG_EINGABEFELD_INFO: 'Suchbegriff oder Weiterbildung',

  ORT_EINGABEPARAMETER_FEHLERHAFT: 'Geben Sie eine gültige Ortsbezeichnung oder PLZ ein',
  ORT_EINGABEPARAMETER_PLZ: 'Bitte geben Sie eine 5-stellige PLZ an',
  ORT_EINGABEFELD_INFO: 'Wo? (Bundesland, Ort oder PLZ)',

  GEWAEHLTER_BILDUNGSZIEL: 'Gewähltes Weiterbildungsziel',
  GEWAEHLTE_BILDUNGSZIELE: 'Gewählte Weiterbildungsziele',

  GEWAEHLTER_WEITERBILDUNGSBEREICH: 'Gewählter Weiterbildungsbereich',
  GEWAEHLTE_WEITERBILDUNGSBEREICHE: 'Gewählte Weiterbildungsbereiche',

  UMKREIS_SUCHEINGABE_LABEL: 'Sucheingabe Ort',
  UMKREISAUSWAHL_LABEL: 'Umkreis',
  UMKREISAUSWAHL_TITLE: 'Zur Änderung Suchumkreis Ortseingabe erforderlich',

  SUCHTYP_LABEL: 'Auswahl Suchtyp',

  KEINE_ERGEBNISSE: 'keine Ergebnisse',
  ZEICHEN_WEITERE: '…',
  SORTIEREN_NACH: 'Sortieren nach:',
  ORT_EINGABE_MIN_LENGTH: (minLength: number) => `Bitte mindestens ${minLength} Zeichen eingeben`
});
